import React from 'react';
import PropTypes from 'prop-types';
import Tippy from '@tippyjs/react';

const toggleTrackStyle = (isOn) => ({
  width: '36px',
  height: '20px',
  minWidth: '36px',
  backgroundColor: isOn ? 'var(--od-c-1982c4, #1982C4)' : 'var(--od-c-e9eaeb, #E9EAEB)',
  borderRadius: '9999px',
  position: 'relative',
  cursor: 'pointer',
  padding: '2px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: isOn ? 'flex-end' : 'flex-start',
  transition: 'background-color 0.2s ease',
});

const toggleThumbStyle = {
  width: '16px',
  height: '16px',
  backgroundColor: 'var(--od-c-ffffff, white)',
  borderRadius: '9999px',
  boxShadow: '0px 1px 3px 0px rgba(10,13,18,0.1), 0px 1px 2px -1px rgba(10,13,18,0.1)',
  flexShrink: 0,
};

const labelStyle = {
  fontFamily: "'Open Sans', sans-serif",
  fontWeight: 500,
  fontSize: '14px',
  lineHeight: '20px',
  color: 'var(--od-c-414651, #414651)',
  whiteSpace: 'nowrap',
};

const helpIconStyle = {
  fontSize: '13px',
  color: 'var(--od-c-717680, #717680)',
  cursor: 'help',
};

const tooltipContentStyle = {
  fontFamily: "'Open Sans', sans-serif",
  fontWeight: 600,
  fontSize: '12px',
  lineHeight: '18px',
  textAlign: 'center',
  whiteSpace: 'pre-line',
};

const CurrencyConversionToggle = ({
  enabled,
  onToggle,
  label,
  tooltip,
}) => {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
      <div
        style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer' }}
        onClick={onToggle}
        role="switch"
        aria-checked={enabled}
      >
        <div style={toggleTrackStyle(enabled)}>
          <div style={toggleThumbStyle} />
        </div>
        <span style={labelStyle}>{label}</span>
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
        <Tippy
          content={
            <span style={tooltipContentStyle}>
              {tooltip}
            </span>
          }
          placement="bottom"
          theme="dark"
          maxWidth={235}
        >
          <i className="fas fa-info-circle" style={helpIconStyle}></i>
        </Tippy>
      </div>
    </div>
  );
};

CurrencyConversionToggle.propTypes = {
  enabled: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  tooltip: PropTypes.string.isRequired,
};

export default CurrencyConversionToggle;
